import { CompanyBrandingPost } from '@interfaces/Company.interface';

function isUploadedFile(value: CompanyBrandingPost['icon']): value is Blob {
  return value instanceof Blob && value.size > 0;
}

function appendImage(
  formData: FormData,
  key: 'icon' | 'logo',
  value: CompanyBrandingPost['icon']
): void {
  if (!isUploadedFile(value)) return;

  const filename =
    value instanceof File && value.name
      ? value.name
      : `${key}.png`;
  formData.append(key, value, filename);
}

export function buildCompanyBrandingFormData(
  dto: CompanyBrandingPost
): FormData {
  const formData = new FormData();
  formData.append(
    'company_branding_colour',
    String(dto.company_branding_colour ?? '')
  );
  formData.append('font_family', dto.font_family ?? '');
  appendImage(formData, 'icon', dto.icon);
  appendImage(formData, 'logo', dto.logo);

  return formData;
}
